import React from "react";

const Text3 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        Så funkar <i>din</i>BiZ-analysen 
      </p>
  
      <div className="content-text mt-4">
        <p>
          Ett första steg mot lönsamhet och lön är att identifiera vilket ”Täckningsbidrag” vart och ett av dina 
          erbjudanden faktiskt tillför firman för att täcka hela den <i>fasta</i> kostnadsmassan.                
        </p>
        <p>
          <i>din</i>BiZ visar automatiskt täckningsbidraget enligt formeln                    
        </p>
        <p className="ms-4">
          <i>Intäkter - <span className="strong">Rörliga</span> Kostnader = Täckningsbidrag </i>                
        </p>
        <p>
          Ur täckningsbidragets storlek från varje erbjudande kan du sortera fram utbudsmixen med bäst lönsamhetspotential 
          och satsa huvuddelen av dina resurser där.                    
        </p>

        <p className="heading2 mt-4">
          Slimmade Kostnader ger Större Lön                            
        </p>
        <p>
          <i>din</i>BiZ lägger samman täckningsbidraget från varje erbjudande i ditt planerade utbud och visar summan som
          ”Årstäckningsbidrag” - alltså behållning av årets försäljning <i>efter</i> att <span className="strong">rörliga </span> 
          kostnader dragits av. Så här                       
        </p>
        <p className="ms-4">
          <i>Årets Intäkter - Årets <span className="strong">Rörliga</span> Kostnader = Årstäckningsbidrag</i>                       
        </p>
        <p>
          Lönsamhet slutligen är det som återstår av årstäckningsbidraget <i>efter avdrag</i> för företagets 
          <span className="strong"> fasta</span> kostnader. Alltså                       
        </p>
        <p className="ms-4">
          <i>
            Årstäckningsbidrag - Årets <span className="strong">Fasta</span> Kostnader = Årets 
            <span className="strong"> Lönsamhet</span>
          </i>              
        </p>
        
        <p className="heading2 mt-4">
          Från Brutto- till Nettolön
        </p>
        <p>
          För att visa din nettolön per månad drar <i>din</i>BiZ av gällande skatter och 
          avgifter enligt formeln                        
        </p>
        <p className="ms-4">
          <i>Årets Lönsamhet - Skatter & Avgifter = Din <span className="strong">LÖN</span></i>                       
        </p>
        <p>
          <i>din</i>BiZ ger ett bra närmevärde på möjligt löneuttag och du ges möjlighet att justera beräkningen 
          efter individuella skatteförhållanden. Konsultera gärna Skatteverket och din deklaration innan bara.                        
        </p>

        <p className="heading2 mt-4">
          Vägen till Framgång                           
        </p>
        <p>
          Hur ser vägen ut från där du står idag till där du vill vara om tre år? Vilka hinder, kostnader, 
          resurser ser du? Vilka möjligheter och resultat?                         
        </p>
        <p>
          Framför allt: Vilka <span className="strong">Åtgärder</span> från din sida kommer att behövas för att lyckas, från och med idag tills 
          du har en etablerad och väl fungerande verksamhet? Med <i>din</i>BiZ kan du effektivt  definiera och hantera 
          nödvändiga åtgärder hela vägen till mål.                        
        </p>

        <p className="heading2 mt-4">
          Mot Ökad Lönsamhet                           
        </p>
        <p>
          Få startups som kört <i>din</i>BiZ genom åren har varit helt nöjda med månadslönen på första försöket. 
          Vanligen behövs 2 - 3 olika tillfällen för att tillfredställande utvärdera affärsidéns möjligheter och 
          lönsamhetspotential och få stabilt underlag för dina viktiga affärsbeslut.                           
        </p>
        <p>
          (Orsaken är att du vanligtvis behöver tid att tänka, skissa, undersöka mellan passen. Hur du skaffar bra 
          dataunderlag avhandlas under Flik: "Förberedelser".)                         
        </p>
        <p>
          Alla <i>processer</i> i en affärsmodell kan kalibreras för <i>högre lönsamhet</i>. Inledningsvis vill du 
          därför identifiera och förstå <i>vilka</i> affärsprocesser det gäller - i ditt unika fall. Vilka processer 
          i din planerade verksamhet kan snabbast, enklast, billigast realisera högre lönsamhet?                         
        </p>
       
       
             
      </div>
    </>
  );
}
export default Text3;